<div class="SAS_Navbar">
  <!-- Header -->
  <app-outer-pages-header></app-outer-pages-header>

  <section class="about-jtc top-background no-printme">
    <div class="background-image-awarness">
      <div class="container">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb custom-breadcrumb">
            <li class="breadcrumb-item">
              <a [routerLink]="['/']">الرئيسية</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              زيادة الوعى بالاضطرابات والتعامل معها
            </li>
          </ol>
        </nav>
        <h1 class="sub-title">زيادة الوعى بالاضطرابات والتعامل معها</h1>
      </div>
    </div>
  </section>

  <div class="intro2">
    <!-- <div class="container">
      <h4 class="sub-title heading-title mb-4 text-site-color"> زيادة الوعى بالاضطرابات والتعامل معها </h4>
    </div> -->

    <div class="container">
      <div class="WhoAreWe section-padding">
        <!-- <h3 class="text-center heading-title mb-4 text-site-color borderAfter">
          أسئلة وأجوبة عن التلعثم
        </h3> -->
        <div class="section-title">
          <h2>أسئلة وأجوبة عن التلعثم</h2>
        </div>
        <!-- أسئلة وأجوبة عن التلعثم -->
        <div class="row mb-4">
          <div class="col-12">
            <div class="accordion" id="accordionExample">
              <!-- ما هو التلعثم؟ -->
              <div class="card2">
                <div
                  class="card-header"
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseOneSt"
                  aria-expanded="true"
                  aria-controls="collapseThree"
                >
                  ما هو التلعثم؟
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>

                <div
                  id="collapseOneSt"
                  class="collapse show"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    <p>
                      التلعثم يطلق عليه أيضا التأتأة وهوحالة اضطراب في طلاقة
                      وسلاسة الكلام، وقد يكون على شكل تكرار ( تقتتلعثم)، توقف
                      مفاجئ بدون صوت )أو /و إطالة للأحرف أو المقاطع الصوتية
                      تا||العثم)، وقد يرافق هذه المظاهر إيماءات وحركات جسمية
                      أخرى ترتبط بالتوتر أو بالميل نحو تجنب الكلام.
                    </p>
                  </div>
                </div>
              </div>

              <div class="card2">
                <div
                  class="card-header"
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseTwoSt"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                >
                  هل يتلعثم المتحدثون الطبيعيون أحيانا:
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>

                <div
                  id="collapseTwoSt"
                  class="collapse"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    <p>
                      في بداية مراحل اكتسابهم للكلام، أما الكبار فقد يتخلل
                      كلامهم مقاطع صوتية معينة مثل ( أ / أم م م )أو يكررون بعض
                      الكلمات أو أشباه الجمل والأصوات ولكن هذه الاضطرابات
                      البسيطة في الطلاقة تعتبر طبيعية ولا تستدعي الاهتمام غالبا،
                      ولا يرافق هذه الظواهر أي علامات أو إيماءات ناتجة عن توتر
                      أو اهتمام من ناحية المتكلم.
                    </p>
                  </div>
                </div>
              </div>

              <!-- ما هي أسباب التلعثم؟ -->
              <div class="card2">
                <div
                  class="card-header"
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseThreeSt"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                >
                  ما هي أسباب التلعثم؟
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>

                <div
                  id="collapseThreeSt"
                  class="collapse"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    <p>
                      ما تزال أسباب التلعثم غير محددة، وتتضمن بعض الاحتمالات
                      وجود خلل في تناسق حركة عضلات الكلام، وقد يكون سبب التلعثم
                      مختلفة تماما عن سبب استمراره ، أو زيادة شدته. وغالبا ما
                      ينتج التلعثم عن اشتراك عدة عوامل جينية وعصبية وبيئية، أو
                      قد يكون لدى كل شخص سببا مختلف عن غيره من الأشخاص.
                    </p>
                  </div>
                </div>
              </div>

              <div class="card2">
                <div
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseForthSt"
                  aria-expanded="false"
                  aria-controls="collapseForth"
                  class="card-header"
                >
                  السؤال مهم: هل ينتج التلعثم عن مشاكل عاطفية أو نفسية؟
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>
                <div
                  id="collapseForthSt"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample"
                  class="collapse"
                >
                  <div class="card-body">
                    <p>
                      الأطفال الذين يتلعثمون لا يعانون من المشاكل النفسية أكثر
                      من الذين لا يتلعثمون، وعموما لا يوجد لسبب يجزم بأن الصدمات
                      العاطفية تسبب التلعثم، في الوقت نفسه فإن التعامل مع
                      التلعثم قد يكون صعبة جدا مع بعض الأشخاص مما قد يؤثر بشكل
                      سلبي على عدم ممارسة حياتهم بشكل طبيعي.
                    </p>
                  </div>
                </div>
              </div>

              <!-- في أي سن يظهر التلعثم غالبا؟ -->
              <div class="card2">
                <div
                  class="card-header"
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseFifthSt"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                >
                  في أي سن يظهر التلعثم غالبا؟
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>

                <div
                  id="collapseFifthSt"
                  class="collapse"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    <p>
                      غالبا ما يظهر التلعثم في - عمر مبكر جدا بين السنة وخمل
                      لسنوات ولكن قد يظهر أحيانا خلال سن المدرسة ونادرا خلال سن
                      الرشد.
                    </p>
                  </div>
                </div>
              </div>

              <div class="card2">
                <div
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseSixSt"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                  class="card-header"
                >
                  إذا بدات أحس أن طفلي، بدأ يتلعثم، فهل علي الانتظار أم طلبا
                  المساعدة؟
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>
                <div
                  id="collapseSixSt"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample"
                  class="collapse"
                >
                  <div class="card-body">
                    <p>
                      عليك بطلب الاستشارة من أخصائي اللغة والتخاطب متي لاحظت ذلك
                      والأهم متى لاحظ طفلك ذلك، و كلما عولجت المشكلة مبكرا قلت
                      مضاعفاتها.
                    </p>
                  </div>
                </div>
              </div>

              <!-- هل يمكن علاج التلعثم بعد نشوئه؟-->
              <div class="card2">
                <div
                  class="card-header"
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseSevenSt"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                >
                  هل يمكن علاج التلعثم بعد نشوئه؟
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>

                <div
                  id="collapseSevenSt"
                  class="collapse"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    <p>
                      نعم هناك عدة طرق ناجحة لعلاج الأطفال والكبار من التلعثم،
                      ولكن لا توجد ثوابت علمية تدل على أفضلية إحدى هذه الطرق عن
                      غيرها.
                    </p>
                  </div>
                </div>
              </div>

              <!-- هل يمكن الشفاء من التلعثم نهائيا؟-->
              <div class="card2">
                <div
                  class="card-header"
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseEightSt"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                >
                  هل يمكن الشفاء من التلعثم نهائيا؟
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>

                <div
                  id="collapseEightSt"
                  class="collapse"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    <p>
                      بداية لابد من معرفة ان التلعثم سلوك وليس مرضا, لهذا فإن
                      العلاج يجب أن يهدف إلى التحسين من طلاقة الكلام والتواصل
                      بنجاح على المدى البعيد بدلا من التقليل من التلعثم على
                      المدى القريب.
                    </p>
                  </div>
                </div>
              </div>

              <div class="card2">
                <div
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseNineSt"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                  class="card-header"
                >
                  ما الذى على فعله عندما أسمع طفلا لديه مشكلة فى الطلاقة؟
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>
                <div
                  id="collapseNineSt"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample"
                  class="collapse"
                >
                  <div class="card-body">
                    <p>
                      قد لا يعى الطفل أن لديه مشكلة فى طلاقة الكلام, وإذا كان
                      ذلك فلا تعره اى اهتمام لطريقة كلامة وتجنب التعليقات مثل
                      (أعد من البداية, فكر قبل أن تتكلم, تكلم بهدوء أو لا تاكل
                      الكلام) فإنها لا تفيد فى شيء بل حاول أن تصغى للطفل بصبر
                      وانتباه إلى ما يقوله وليس إلى طريقة كلامة وإذا بدا أن
                      الطفل متضايق من طريقة كلامة فحاول أن توضح له الصعوبة التى
                      يواجهها بطريقة تسانده مثل (يبدو أن ذلك صعب لتقوله, لا بأس,
                      أو أن كثيرا من الأطفال يعانون من مشاكل فى الكلام) فهذه
                      العبارات تساعد الطفل على التكيف مع مشكلة التلعثم بطريقة
                      أكثر إيجابية.
                    </p>
                  </div>
                </div>
              </div>

              <div class="card2">
                <div
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseTenSt"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                  class="card-header"
                >
                  ما الذي علي فعله عندما أسمع شخصا راشدأ يتلعثم؟
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>
                <div
                  id="collapseTenSt"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample"
                  class="collapse"
                >
                  <div class="card-body">
                    <p>
                      يستحق الأشخاص الذين يتلعثمون الصبر والاهتمام كما يستحقه
                      غيرهم من الذين لا يتلعثمون فلا تلتفت عنهم أو تقاطعهم
                      أوتستعجلهم أوتكمل عنهم كلماتهم فإن محاولة مساعدتهم على
                      الكلام قد يولد لديهم القلق والوعي بذاتهم مما يزيد الأمر
                      سوءا.
                    </p>
                  </div>
                </div>
              </div>

              <div class="card2">
                <div
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseElevenSt"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                  class="card-header"
                >
                  من الذي يمكنه المساعدة في مشكلة التلعثم؟
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>
                <div
                  id="collapseElevenSt"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample"
                  class="collapse"
                >
                  <div class="card-body">
                    <p>
                      أخصائيو اللغة والتخاطب الذين لديهم الخبرة والمعرفة في
                      كيفية التعامل مع مشاكل التلعثم لدى الأطفال والكبار. وهم
                      المدربون على تقييمهم وإعداد الخطة العلاجية لتحسين الكلام
                      لديهم.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- اضطرابات النطق -->
        <div class="section-title">
          <h2>اضطرابات النطق</h2>
        </div>

        <div class="row mb-4">
          <div class="col-12">
            <div id="accordionExample2" class="accordion">
              <div class="card2">
                <div
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseOneTp"
                  aria-expanded="true"
                  aria-controls="collapseThree"
                  class="card-header"
                >
                  ما هي اضطرابات النطق؟
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>
                <div
                  id="collapseOneTp"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample2"
                  class="collapse show"
                >
                  <div class="card-body">
                    <p>
                      معظم الأطفال يخطؤون عند تعلم نطق كلمات جديدة، وتحدث
                      اضطرابات النطق عندما يستمر الخطأ في النطق لما بعد عمل
                      معين، حيث أن لكل صوت عمر معين لنطقه بطريقة سليمة. تؤثر
                      اضطرابات النطق على إصدار الأصوات ( أي مخارج الأحرف)
                    </p>
                  </div>
                </div>
              </div>

              <div class="card2">
                <div
                  id="general_info"
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseTwoTp"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                  class="card-header"
                >
                  هل من الممكن أن يصاب البالغ باضطرابات النطق؟
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>
                <div
                  id="collapseTwoTp"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample2"
                  class="collapse"
                >
                  <div class="card-body">
                    <p>
                      يمكن للشخص البالغ أن يصاب باضطرابات النطق، وقد تستمر مشاكل
                      النطق الموجودة منذ الصغر عند بعض البالغين وقد تحدث للبعض
                      الآخر بعد سكتة دماغية أو إصابة في الرأس.
                    </p>
                  </div>
                </div>
              </div>

              <div class="card2">
                <div
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseThreeTp"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                  class="card-header"
                >
                  ما هي أسباب اضطرابات النطق؟
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>
                <div
                  id="collapseThreeTp"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample2"
                  class="collapse"
                >
                  <div class="card-body">
                    <p>
                      تحدث معظم اضطرابات النطق بدون سبب معين إلا أن بعض الأسباب
                      المعروفة هي كما يلي :
                    </p>
                    <p class="my-0">1. الاضطرابات العضلية</p>
                    <p class="my-0">
                      2. (الاضطرابات العضوية مثل (الحنك المشقوق
                    </p>
                    <p class="my-0">3. المتلازمات الجينية</p>
                    <p class="my-0">
                      4. ضعف السمع :فالأطفال الذين يعانون من التهابات الأذن
                      باستمرار هم في خطر التعرض لمشاكل النطق
                    </p>
                    <p class="my-0">
                      5. الاضطرابات العصبية (مثل الشلل الدماغي)
                    </p>
                  </div>
                </div>
              </div>

              <div class="card2">
                <div
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseForthTp"
                  aria-expanded="false"
                  aria-controls="collapseForth"
                  class="card-header"
                >
                  ما هى مظاهر اضطرابات النطق؟
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>
                <div
                  id="collapseForthTp"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample2"
                  class="collapse"
                >
                  <div class="card-body">
                    <p class="my-0">• الحذف :مثل سيارة يارة</p>
                    <p class="my-0">• الاستبدال :مثل شجرة سجرة</p>
                    <p class="my-0">
                      • التشويه ( إصدار أصوات مشابهة للصوت المرغوب ولكنه ليس
                      دقيقا )
                    </p>
                    <p class="my-0">• الإضافة :مثل أسود أو سود</p>
                    <p>
                      ليس كل الاستبدال أو التشويه في الأصوات أخطاء في النطق، بل
                      من الممكن أن تكون اختلافا في اللغة أو اللهجة
                    </p>
                  </div>
                </div>
              </div>

              <div class="card2">
                <div
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseFifthTp"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                  class="card-header"
                >
                  كيف يمكن تشخيص اضطرابات النطق؟
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>
                <div
                  id="collapseFifthTp"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample2"
                  class="collapse"
                >
                  <div class="card-body">
                    <p>
                      أخصائي التخاطب و البلع هو الشخص المسؤول عن تقييم و تشخيص
                      الأطفال والكبار الذين يعانون من مشاكل في النطق.
                    </p>
                  </div>
                </div>
              </div>

              <div class="card2">
                <div
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseSixTp"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                  class="card-header"
                >
                  ما هي العلاجات المتوفرة للأشخاص الذين يعانون من اضطرابات
                  النطق؟
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>
                <div
                  id="collapseSixTp"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample2"
                  class="collapse"
                >
                  <div class="card-body">
                    <p>
                      تزيد أهمية علاج اضطرابات النطق خاصة عندما تؤثر هذه على
                      التطور الاجتماعي أو الأكاديمي أو الحالة الوظيفية. تعتمد
                      طرق العلاج على تصحيح مخارج الأصوات واستخدام الأصوات في
                      اللغة من خلال تدريبات مختلفة، وقد يوصي أخصائي التخاطب
                      والبلع بالبدء بتدريبات النطق إذا كان الخطأ لا يتناسب مع
                      عمر الشخص أو ليس بسبب اختلاف في اللهجة.
                    </p>
                  </div>
                </div>
              </div>

              <div class="card2">
                <div
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseSevenTp"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                  class="card-header"
                >
                  كيف من الممكن أن أساعد في تعليم طفلي النطق بشكل صحيح؟
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>
                <div
                  id="collapseSevenTp"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample2"
                  class="collapse"
                >
                  <div class="card-body">
                    <p>
                      يتم ذلك بتقديم مثال جيد بلفظ الكلمة بطريقة صحيحة وعدم
                      مقاطعة أو تصحيح الطفل بشكل دائم وعدم مضايقته والاستهزاء
                      به.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--  الرنين الصوتى  -->
        <div class="section-title">
          <h2>الرنين الصوتى</h2>
        </div>

        <div class="row mb-4">
          <div class="col-12">
            <div id="accordionExample3" class="accordion">
              <div class="card2">
                <div
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseOneRs"
                  aria-expanded="true"
                  aria-controls="collapseThree"
                  class="card-header"
                >
                  ما هو الرنين الصوتى؟
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>
                <div
                  id="collapseOneRs"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample3"
                  class="collapse show"
                >
                  <div class="card-body">
                    <p>
                      الرنين الصوتي او صدى الصوت هو نوعية الصوت المسموع خلال
                      الكلام والتحولات التي تحصل للصوت الناتج عن حركة الحبال
                      الصوتية.
                    </p>
                  </div>
                </div>
              </div>

              <div class="card2">
                <div
                  id="general_info"
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseTwoRs"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                  class="card-header"
                >
                  ما الذي يحدد الرنين الصوتي؟
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>
                <div
                  id="collapseTwoRs"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample3"
                  class="collapse"
                >
                  <div class="card-body">
                    <p>يتحدد الرنين الصوتي بالتالي :</p>
                    <p class="my-0">1. حجم وشكل تجاويف مجرى الهواء.</p>
                    <p class="my-0">
                      2. تجويف البلعوم :طول وحجم تجويف البلعوم.
                    </p>
                    <p class="my-0">3. تجويف الفم :حجم وشكل تجويف الفم.</p>
                    <p class="my-0">4. تجويف الأنف :تكوين وشكل تجويف الأنف.</p>
                    <p class="my-0">
                      5. الاضطرابات العصبية (مثل الشلل الدماغي)
                    </p>
                  </div>
                </div>
              </div>

              <div class="card2">
                <div
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseThreeRs"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                  class="card-header"
                >
                  ما هو عمل العضلة التي تتحكم بإغلاق مجرى الأنف عن مجرى الفم؟
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>
                <div
                  id="collapseThreeRs"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample3"
                  class="collapse"
                >
                  <div class="card-body">
                    <p>وتدعى أيضا عضلة الحنك المتحرك البلعومي :</p>
                    <p class="my-0">
                      1. جميع الأصوات تتأثر بأي تغيير يحصل في تجاويف مجرى الهواء
                    </p>
                    <p class="my-0">2. الفرق بين الأطفال والكبار</p>
                    <p class="my-0">3. الفرق بين الذكور والإناث</p>
                    <p class="my-0">4. الفرق بين الأشخاص طوال وقصار القامة</p>
                  </div>
                </div>
              </div>

              <div class="card2">
                <div
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseForthRs"
                  aria-expanded="false"
                  aria-controls="collapseForth"
                  class="card-header"
                >
                  ما هي أجزاء الجسم المسؤولة عن تحديد الرنين الصوتي؟
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>
                <div
                  id="collapseForthRs"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample3"
                  class="collapse"
                >
                  <div class="card-body">
                    <p>
                      الأجزاء المسؤولة عن إغلاق تجويف الأنف عن تجويف الفم هي :
                    </p>
                    <p class="my-0">• اللهاة</p>
                    <p class="my-0">• الجدار الجانبي للبلعوم</p>
                    <p class="my-0">• الجدار الخلفي للبلعوم</p>
                  </div>
                </div>
              </div>

              <div class="card2">
                <div
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseFifthRs"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                  class="card-header"
                >
                  ما هي الاضطرابات الناتجة عن مشاكل الرنين الصوتي؟
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>
                <div
                  id="collapseFifthRs"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample3"
                  class="collapse"
                >
                  <div class="card-body">
                    <p>
                      الخنة المفرطة :هي خروج الهواء بصورة مفرطة من الأنف بدلا من
                      الفم خلال الكلام وخاصة مع الأصوات المخرجة من الفم، ونرى
                      هذه المشكلة عادة عند المرضى المصابين بانشقاق الحنك أو من
                      لديهم فتحة فی لسقف الحلق.
                    </p>
                    <p>
                      الخنة: هي خروج الهواء بشكل كامل من الفم بدلا من الأنف
                      للأصوات ذات الغنة( ن، م ) خلال الكلام، ونرى هذه المشكلة
                      عادة عند المصابين بانسداد تجويف الأنف أو عند المصابين
                      بالزكام.
                    </p>
                    <p>
                      مشاكل الرنين الصوتي المعروفة ب كول دي ساك: وهو عدم خروج
                      الصوت من الحلق نتيجة انسداد البلعوم، ويكون الصوت مثل
                      الغمغمة أو الهمهمة ويتصف الكلام بغير الواضح والمنخفض،
                      وعادة نرى هذا النوع عند المرضى المصابين بتضخم ال لوزتين
                      مما يؤدي إلى انسداد البلعوم.
                    </p>
                    <p>الخنة المختلطة تجمع بين الخنة المفرطة والخنة.</p>
                  </div>
                </div>
              </div>

              <div class="card2">
                <div
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseSixRs"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                  class="card-header"
                >
                  ما هو دور أخصائي التخاطب؟
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>
                <div
                  id="collapseSixRs"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample3"
                  class="collapse"
                >
                  <div class="card-body">
                    <p>
                      يقوم أخصائي التخاطب بتقييم الحالة وذلك بإجراء الاختبارات
                      السريرية والأشعة اللازمة في حال الحاجة إليها، ومن ثم تحديد
                      الجلسات اللازمة و وضع خطة علاجية مناسبة لكل مريضن لتدريبه
                      ومساعدته على تخطي المشكلة .
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--  العوق العقلى  -->
        <div class="section-title">
          <h2>العوق العقلى</h2>
        </div>

        <div class="row mb-4">
          <div class="col-12">
            <div id="accordionExample4" class="accordion">
              <div class="card2">
                <div
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseOneMr"
                  aria-expanded="true"
                  aria-controls="collapseThree"
                  class="card-header"
                >
                  ما هو العوق العقلي؟
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>
                <div
                  id="collapseOneMr"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample4"
                  class="collapse show"
                >
                  <div class="card-body">
                    <p>
                      هو أداء عقلي عام أدنى من المتوسط بكثير ، يحدث بالتزامن مع
                      نقص في السلوك التكيف, ويتضح العجز خلال فترة النمو"، على أن
                      القاصرين عقلية يتطورا ببطء أكبر أو بمعدل مختلف أكثر من
                      الأسوياء ، ويظهر تأخرهم في نواح متعددة بما في ذلك تطور
                      اللغة والكلام.
                    </p>
                  </div>
                </div>
              </div>

              <div class="card2">
                <div
                  id="general_info"
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseTwoMr"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                  class="card-header"
                >
                  ما هي المسميات الأخرى للعوق العقلي؟
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>
                <div
                  id="collapseTwoMr"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample4"
                  class="collapse"
                >
                  <div class="card-body">
                    <p class="my-0">1. التخلف العقلي.</p>
                    <p class="my-0">2. نقص الذكاء.</p>
                    <p class="my-0">3. القصور العقلي.</p>
                    <p class="my-0">4. التأخر العقلي.</p>
                    <p class="my-0">5. تأخر الذكاء.</p>
                  </div>
                </div>
              </div>

              <div class="card2">
                <div
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseThreeMr"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                  class="card-header"
                >
                  كافة المعلومات عن العوق العقلى
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>
                <div
                  id="collapseThreeMr"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample4"
                  class="collapse"
                >
                  <div class="card-body">
                    <p>
                      لمعرفة كافة المعلومات عن العوق العقلى قم بتحميل الملف
                      التالى
                      <a
                        href="assets/files/MentalRetarded.pdf"
                        target="_blank"
                        class="text-site-color"
                      >
                        من هنا
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--   برنامج لي لسيلفرمان   -->
        <div class="section-title">
          <h2>برنامج لي لسيلفرمان</h2>
        </div>

        <div class="row mb-4">
          <div class="col-12">
            <div id="accordionExample5" class="accordion">
              <div class="card2">
                <div
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseOneLe"
                  aria-expanded="true"
                  aria-controls="collapseThree"
                  class="card-header"
                >
                  نبذة عامة:
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>
                <div
                  id="collapseOneLe"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample5"
                  class="collapse show"
                >
                  <div class="card-body">
                    <p>
                      يعد برنامج ل لليلفرمان برنامج ناجح وفعال لعلاج التخاطب
                      والصوت للمرضى المصابين بالباركنسون ( الشلل الرعاشں )وبعض
                      الأمراض العصبية الأخرى.
                    </p>
                    <p>
                      سلمي البرنامج ب لي سيلفرمان تبعا المخترعة البرنامج السيدة
                      لي سيلفرمان lee Silverman Voice Treatment في سنة ۱۹۸۷ وتمت
                      دراسته علميا لمدة تقارب العشرون عاما.
                    </p>
                  </div>
                </div>
              </div>

              <div class="card2">
                <div
                  id="general_info"
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseTwoLe"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                  class="card-header"
                >
                  الأبحاث العلمية:
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>
                <div
                  id="collapseTwoLe"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample5"
                  class="collapse"
                >
                  <div class="card-body">
                    <p>
                      أثبتت نتائج الأبحاث العلمية المنشورة وجود تحسن في ارتفاع
                      وجودة الصوت للاشخاص المصابين بمرض الباركنسون بعد تلقي
                      برنامج لي الليلغرمان العلاجي، كما تؤيد استمر هذ التحسن
                      لمدة تقارب العامين. توضح الأبحاث العلمية الحديثة أن
                      البرنامج العلاجي ساعد في تحسين بشكل أوضة ومشاكل البلع،
                      إضافة إلى ذلك تم دراسة صورتين للدماغ موضحة وجود تغير
                      إيجابي في الدماغ بعد تلقي البرنامج.
                    </p>
                  </div>
                </div>
              </div>

              <div class="card2">
                <div
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseThreeLe"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                  class="card-header"
                >
                  موجز البرنامج:
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>
                <div
                  id="collapseThreeLe"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample5"
                  class="collapse"
                >
                  <div class="card-body">
                    <p>
                      يتكون البرنامج من 16 جلسة لمدة شهر واحد 4(جلسات في الأسبوع
                      ومدة الجلسة الواحدة 60 دقيقة.) يتم تدريب المريض على
                      الاعتماد على نفسه في إصدار الصوت بعلو مناسب ومقبول
                      لمساعدته في زيادة وضوح الكلام.
                    </p>
                    <p>
                      يركز البرنامج على تحللين علو الصوت وتعميم هذا التحسن على
                      التواصل اليومي للمرضى مما يتيح لهم الحفاظ على أو تحسين
                      تواصلهم اللفظي مع الآخرين.
                    </p>
                  </div>
                </div>
              </div>

              <div class="card2">
                <div
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseFourLe"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                  class="card-header"
                >
                  حقائق عن البرنامج:
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>
                <div
                  id="collapseFourLe"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample5"
                  class="collapse"
                >
                  <div class="card-body">
                    <p>
                      تماشي كثافة الجلسات العلاجية مع نظريات التعلم الحركي
                      واكتساب المهارات، بالإضافة إلى نظرية الليونة العصبية (قدرة
                      الجهاز العصبي على التغير كاستجابة للإشارات المرسلة للدماغ
                      التي تعتبر من أساسيات العلاج للوصول إلى أفضل النتائج.
                    </p>
                    <p>
                      أوضحت نتائج الأبحاث العلمية نجاح برنامج لي سيلفرمان
                      العلاجي على جميع مراحل مرض الباركنسون إلا أنه أكثر فعالية
                      حين يتم تقديمه في مراحل مبكرة من المرض.
                    </p>
                    <p>
                      تقل نسبة التحسن في النطق والصوت مع برنامج لي سيلفرمان
                      العلاجي للمرضي الخاضعين الجهاز التحفيز الدماغي العميق
                      (Deep Brain Stimulation) بالمقارنة مع من لم يخضعوا لهذا
                      الاجراء الجراحي.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--    صعوبات البلع عند الأطفال    -->
        <div class="section-title">
          <h2>صعوبات البلع عند الأطفال</h2>
        </div>

        <div class="row mb-4">
          <div class="col-12">
            <div id="accordionExample6" class="accordion">
              <div class="card2">
                <div
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseOneKd"
                  aria-expanded="true"
                  aria-controls="collapseThree"
                  class="card-header"
                >
                  كافة المعلومات عن صعوبات البلع عند الأطفال
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>
                <div
                  id="collapseOneKd"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample6"
                  class="collapse show"
                >
                  <div class="card-body">
                    <p>
                      لمعرفة كافة المعلومات عن صعوبات البلع عند الأطفال قم
                      بتحميل الملف التالى
                      <a
                        href="assets/files/KidsSwallowingDifficulities.pdf"
                        target="_blank"
                        class="text-site-color"
                      >
                        من هنا
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--     صعوبات البلع عند البالغين     -->
        <div class="section-title">
          <h2>صعوبات البلع عند البالغين</h2>
        </div>

        <div class="row mb-4">
          <div class="col-12">
            <div id="accordionExample6" class="accordion">
              <div class="card2">
                <div
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseOneKd"
                  aria-expanded="true"
                  aria-controls="collapseThree"
                  class="card-header"
                >
                  كافة المعلومات عن صعوبات البلع عند البالغين
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>
                <div
                  id="collapseOneKd"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample6"
                  class="collapse show"
                >
                  <div class="card-body">
                    <p>
                      لمعرفة كافة المعلومات عن صعوبات البلع عند البالغين قم
                      بتحميل الملف التالى
                      <a
                        href="assets/files/AdultsSwallowingDifficulities.pdf"
                        target="_blank"
                        class="text-site-color"
                      >
                        من هنا
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--      تأهيل ضعاف السمع      -->
        <div class="section-title">
          <h2>تأهيل ضعاف السمع</h2>
        </div>

        <div class="row mb-4">
          <div class="col-12">
            <div id="accordionExample7" class="accordion">
              <div class="card2">
                <div
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseOneHp"
                  aria-expanded="true"
                  aria-controls="collapseThree"
                  class="card-header"
                >
                  كافة المعلومات عن تأهيل ضعاف السمع
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>
                <div
                  id="collapseOneHp"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample7"
                  class="collapse show"
                >
                  <div class="card-body">
                    <p>
                      لمعرفة كافة المعلومات عن تأهيل ضعاف السمع قم بتحميل الملف
                      التالى
                      <a
                        href="assets/files/تأهيل ضعاف السمع.pdf"
                        target="_blank"
                        class="text-site-color"
                      >
                        من هنا
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--       اضطرابات فرط الحركة       -->
        <div class="section-title">
          <h2>اضطرابات فرط الحركة</h2>
        </div>

        <div class="row mb-4">
          <div class="col-12">
            <div id="accordionExample8" class="accordion">
              <div class="card2">
                <div
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseOneTm"
                  aria-expanded="true"
                  aria-controls="collapseThree"
                  class="card-header"
                >
                  كافة المعلومات عن اضطرابات فرط الحركة
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>
                <div
                  id="collapseOneTm"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample8"
                  class="collapse show"
                >
                  <div class="card-body">
                    <p>
                      لمعرفة كافة المعلومات عن اضطرابات فرط الحركة قم بتحميل
                      الملف التالى
                      <a
                        href="assets/files/ماهي اضطرابات فرط الحركة.pdf"
                        target="_blank"
                        class="text-site-color"
                      >
                        من هنا
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--        التشجيع المبكر لتطور اللغة من الولادة إلى السنة الأولى        -->
        <div class="section-title">
          <h2>التشجيع المبكر لتطور اللغة من الولادة إلى السنة الأولى</h2>
        </div>

        <div class="row mb-4">
          <div class="col-12">
            <div id="accordionExample9" class="accordion">
              <div class="card2">
                <div
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseOneEc"
                  aria-expanded="true"
                  aria-controls="collapseThree"
                  class="card-header"
                >
                  التشجيع المبكر لتطور اللغة من الولادة إلى السنة الأولى
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>
                <div
                  id="collapseOneEc"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample9"
                  class="collapse show"
                >
                  <div class="card-body">
                    <p>
                      لمعرفة كيفية التشجيع المبكر لتطور اللغة من الولادة إلى
                      السنة الأولى قم بتحميل الملف التالى
                      <a
                        href="assets/files/التشجيع المبكر لتطور اللغة من الولادة الي السنة الالى.pdf"
                        target="_blank"
                        class="text-site-color"
                      >
                        من هنا
                      </a>
                    </p>
                  </div>
                </div>
              </div>

              <div class="card2">
                <div
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseTwoEc"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                  class="card-header"
                >
                  نشاطات يومية لتحفيز لغة الطفل
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>
                <div
                  id="collapseTwoEc"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample9"
                  class="collapse"
                >
                  <div class="card-body">
                    <p>
                      لمعرفة النشاطات يومية لتحفيز لغة الطفل قم بتحميل الملف
                      التالى
                      <a
                        href="assets/files/نشاطات يومية لتحفيز لغة الطفل.pdf"
                        target="_blank"
                        class="text-site-color"
                      >
                        من هنا
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- لغة الطفل   -->
        <div class="section-title">
          <h2>لغة الطفل</h2>
        </div>

        <div class="row mb-4">
          <div class="col-12">
            <div id="accordionExample10" class="accordion">
              <div class="card2">
                <div
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseOneTm"
                  aria-expanded="true"
                  aria-controls="collapseThree"
                  class="card-header"
                >
                  كافة المعلومات عن لغة الطفل
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>
                <div
                  id="collapseOneTm"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample10"
                  class="collapse show"
                >
                  <div class="card-body">
                    <p>
                      لمعرفة كافة المعلومات عن لغة الطفل قم بتحميل الملف التالى
                      <a
                        href="assets/files/لغة الطفل.pdf"
                        target="_blank"
                        class="text-site-color"
                      >
                        من هنا
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--  مراحل تطور النطق واللغة    -->
        <div class="section-title">
          <h2>مراحل تطور النطق واللغة</h2>
        </div>

        <div class="row mb-4">
          <div class="col-12">
            <div id="accordionExample11" class="accordion">
              <div class="card2">
                <div
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseOneTd"
                  aria-expanded="true"
                  aria-controls="collapseThree"
                  class="card-header"
                >
                  كافة المعلومات عن مراحل تطور النطق واللغة
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>
                <div
                  id="collapseOneTd"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample11"
                  class="collapse show"
                >
                  <div class="card-body">
                    <p>
                      لمعرفة كافة المعلومات عن مراحل تطور النطق واللغة قم بتحميل
                      الملف التالى
                      <a
                        href="assets/files/مراحل تطور النطق واللغة.pdf"
                        target="_blank"
                        class="text-site-color"
                      >
                        من هنا
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--   إرشادات للأسرة والمعلم     -->
        <div class="section-title">
          <h2>إرشادات للأسرة والمعلم</h2>
        </div>

        <div class="row">
          <div class="col-12">
            <div id="accordionExample12" class="accordion">
              <div class="card2">
                <div
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseOneTpp"
                  aria-expanded="true"
                  aria-controls="collapseThree"
                  class="card-header"
                >
                  إرشادات للأسرة والمعلم
                  <!-- <i class="fas fa-chevron-down mt-1"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow icon"
                  />
                </div>
                <div
                  id="collapseOneTpp"
                  aria-labelledby="general_info"
                  data-parent="#accordionExample12"
                  class="collapse show"
                >
                  <div class="card-body">
                    <p>
                      لمعرفة مجموعة من إرشادات للأسرة والمعلم قم بتحميل الملف
                      التالى
                      <a
                        href="assets/files/إرشاد الأسرة والمعلم.docx"
                        target="_blank"
                        class="text-site-color"
                      >
                        من هنا
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <app-outer-pages-footer></app-outer-pages-footer>
</div>
